export default "__VITE_ASSET__TUDFl9ME__"